/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly itemId: string | null;
        readonly cmsId: number | null;
        readonly link: string | null;
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly contemporaryTrackingString: string | null;
    } | null> | null;
    readonly " $refType": "HpRespHeroModule_componentModule";
};
export type HpRespHeroModule_componentModule$data = HpRespHeroModule_componentModule;
export type HpRespHeroModule_componentModule$key = {
    readonly " $data"?: HpRespHeroModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespHeroModule_componentModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HeroModule",
  "abstractKey": null
};
})();
(node as any).hash = 'aa135c0b8f6ddb2a2dd5b17275564beb';
export default node;
